import script from "./QuestionBodyComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuestionBodyComponent.vue?vue&type=script&setup=true&lang=ts"

import "./QuestionBodyComponent.vue?vue&type=style&index=0&id=f8134400&lang=scss"

const __exports__ = script;

export default __exports__